export enum LocalStorage {
  PaymentLocalData = "paymentLocalData",
  PaymentPageData = "paymentPageData",
  PaymentRetryPaymentData = "__rtpd__",
}
